<template>
  <div class="approvals content-wrapper content-wrapper--align-start">
    <h1>{{ this.$route.params.type }} Overview</h1>
    <template v-if="isFetching">
      <div class="table-options">
        <div class="placeholder-search"></div>
      </div>
      <div class="placeholder-table">
        <div class="placeholder-table__header"></div>
      </div>
    </template>
    <template v-else>
      <div class="table-options">
        <span>Filters:</span>
        <div class="select-container select-container--no-label">
          <select @change="getTasks()" v-model="statusFilter" data-cy="status-filter">
            <option value="">All Statuses</option>
            <option v-for="status in statusList" v-bind:key="status.id" :value="status.id">{{ status.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select @change="getTasks()" v-model="marketFilter">
            <option value="">All Languages</option>
            <option v-for="language in languageList" :key="language.id" :value="language.id">{{ language.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <div class="select-container select-container--no-label">
          <select @change="getTasks()" v-model="siteFilter">
            <option value="">All Sites</option>
            <option v-for="site in siteList" v-bind:key="site.id" :value="site.id">{{ site.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <!-- <div class="select-container select-container--no-label">
          <select @change="getTasks()" v-model="monthFilter">
            <option value="-1">All Months</option>
            <option v-for="month in monthList" v-bind:key="month.id" :value="month.id">{{ month.name }}</option>
          </select>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div> -->
        <div class="select-container select-container--no-label">
          <select @change="getTasks()" v-model="freelancerFilter">
            <option value="">All Freelancers</option>
            <option v-for="freelancer in freelancers" v-bind:key="freelancer.id" :value="freelancer.id">{{ freelancer.content.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
        </div>
        <!-- <div class="search-container">
          <svg data-v-8cd888b6 xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"><path fill="#bcbccb" data-v-8cd888b6 d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
          <input class="input input--search-icon" v-model="searchFilter" placeholder="Search brand, anchor text, title or user" />
        </div> -->
      </div>
      <div class="table">
        <div class="table__headers">
          <div class="table__header"></div>
          <div class="table__header">Status</div>
          <div class="table__header">Deadline</div>
          <div class="table__header">Sites</div>
          <div class="table__header" v-if="this.$route.params.type == 'review'">Brand</div>
          <div class="table__header" v-if="this.$route.params.type == 'seo'">Keyword</div>
          <div class="table__header" v-if="this.$route.params.type == 'linkbuilding'">Website</div>
          <div class="table__header">Language</div>
          <div class="table__header" v-if="this.$route.params.type == 'linkbuilding'">Topic</div>
          <div class="table__header" v-if="this.$route.params.type == 'review' || this.$route.params.type == 'seo'">Title</div>
          <div class="table__header">Submit Date</div>
          <div class="table__header">Freelancer</div>
          <div class="table__header">Created By</div>
        </div>
        <template v-for="(task, index) in tasks">
          <router-link :key="task.id" class="table__row" :to="{ path: '/task/:id', name: 'taskId', params: { id: task.id } }" :data-cy="`task-${index}`">
            <div class="table__cell">
              <div
                class="circle"
                :class="[{ 'circle--active': task.status == 'approved' }, { 'circle--warning': task.status == 'pending-review' }, { 'circle--exported': task.status == 'exported' }]"
              ></div>
            </div>
            <div class="table__cell">{{ getStatus(task.status) }}</div>
            <div class="table__cell">{{ dateFormatted(task.deadlineAt) }}</div>
            <div class="table__cell table__cell--icon">
              <div class="sites" v-for="site in task.content.siteIds" :key="site">
                <img :src="require(`@/assets/sites/${site}.svg`)" />
              </div>
            </div>
            <div class="table__cell" v-if="hasBrand(task.type)">{{ getBrandName(task.content.brandId) }}</div>
            <div class="table__cell" v-if="task.content.keyword">{{ task.content.keyword }}</div>
            <div class="table__cell" v-if="task.type == 'linkbuilding'">{{ task.content.url }}</div>
            <div class="table__cell">{{ getLanguage(task.marketId) }}</div>
            <div class="table__cell" v-if="task.type == 'linkbuilding'">{{ task.content.topic }}</div>
            <div class="table__cell" v-if="task.type == 'review' || task.type == 'seo'">{{ task.content.title }}</div>
            <div class="table__cell">{{ dateFormatted(task.submittedAt) }}</div>
            <div class="table__cell">{{ getUserName(task.claimedBy) }}</div>
            <div class="table__cell">{{ getUserName(task.createdBy) }}</div>
            <!-- prettier-ignore -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
          </router-link>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'overview',
  data() {
    return {
      taskList: [],
      monthList: [
        { id: 0, name: 'January' },
        { id: 1, name: 'February' },
        { id: 2, name: 'March' },
        { id: 3, name: 'April' },
        { id: 4, name: 'May' },
        { id: 5, name: 'June' },
        { id: 6, name: 'July' },
        { id: 7, name: 'August' },
        { id: 8, name: 'September' },
        { id: 9, name: 'October' },
        { id: 10, name: 'November' },
        { id: 11, name: 'December' },
      ],
      isFetching: true,
      // searchFilter: '',
      // monthFilter: -1,
      statusFilter: '',
      marketFilter: '',
      siteFilter: '',
      freelancerFilter: '',
    }
  },
  methods: {
    getTasks() {
      var params = {
        endpoint: 'getbyfilters',
        type: this.$route.params.type,
      }
      if (this.statusFilter) {
        params['status'] = this.statusFilter
      }
      if (this.siteFilter) {
        params['site'] = this.siteFilter
      }
      if (this.marketFilter) {
        params['markets'] = this.$store.getters.marketsByLanguageID(this.marketFilter)
      }
      if (this.freelancerFilter) {
        params['claimedby'] = this.freelancerFilter
      }
      this.$store
        .dispatch('fetchTasks', {
          params,
          userId: this.user.data.uid,
        })
        .then((this.isFetching = false))
    },
    getBrandName(id) {
      if (id.length === 0) {
        return ''
      }
      return this.$store.getters.brandNameByID(id)
    },
    getUserName(id) {
      if (id.length === 0) {
        return '-'
      }
      return this.$store.getters.userName(id)
    },
    hasBrand(type) {
      return type === 'review' ? true : false
    },
    getLanguage(marketId) {
      return this.$store.getters.languageByMarketID(marketId)
    },
    getStatus(statusId) {
      return this.$store.getters.statusNamebyID(statusId)
    },
    dateFormatted(submitDate) {
      let date = new Date(submitDate)
      return date.toLocaleString('da-DK')
    },
  },
  mounted: function() {
    this.getTasks()
  },
  watch: {
    '$route.params.type': function() {
      this.getTasks()
    },
  },
  computed: {
    ...mapGetters(['tasks', 'user', 'freelancers', 'languageList', 'oldMarketList', 'siteList', 'statusList']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';
@import '@/assets/shared-styles/input.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/table.scss';
h1 {
  text-transform: capitalize;
}
.table__headers,
.table__row {
  grid-template-columns: 40px 120px 120px 90px 140px 130px 200px 120px 160px 1fr auto;
}
.sites {
  display: inline-flex;
  padding: 0;
  height: 100%;
  width: 2rem;
  img {
    max-height: 2rem;
  }
}
.content-wrapper--align-start {
  grid-template-rows: auto;
  align-content: start;
}
.placeholder-search {
  margin-left: auto;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  width: 240px;
  height: 33px;
}
.search-container {
  width: 240px;
  margin-left: auto;
  position: relative;
}
.search-container > svg {
  position: absolute;
  transform: translateY(-50%);
  top: 45%;
  left: 0.5rem;
}
</style>
